import React from 'react';

import {SingleInput} from 'comp/input';
import {LoaderButton} from 'comp/button';

import styles from './TwoFactor.scss';

const TwoFactorLogin = ({
  isLoading,
  setActivation,
  submitActivation,
}) => {
  return (
    <div
      className={styles.content}
    >
      <div className={styles.text}>
        Please enter the code provided by your preferred authenticator app.
      </div>
      <SingleInput
        ref={setActivation}
        id='activation-code'
        name='activation-code'
        title='Enter Code'
        inputType='text'
        autoFocus
        onReturnKey={submitActivation}
      />
      <LoaderButton
        disabled={isLoading}
        text='Authenticate'
        isLoading={isLoading}
        loadingText='Authenticating...'
        type='action'
        clickAction={submitActivation}
        size='large'
        className={styles.submit}
      />
    </div>
  );
};

TwoFactorLogin.propTypes = {
  isLoading: React.PropTypes.bool,
  setActivation: React.PropTypes.func,
  submitActivation: React.PropTypes.func,
};

export default TwoFactorLogin;



// WEBPACK FOOTER //
// ./src/components/login/components/TwoFactor.jsx